import React, { useState, useEffect } from 'react';
import apiClient from '../../apiClient';
import {
    Button,
    TextField,
    Box,
    Stack,
    Divider,
    Typography,
    FormControl
} from '@mui/material';
import { SelectGenericFromTable } from '../universal/Axios';
import { HandleAuthError, GenericStackTraceValidator } from '../universal/Alert';
import { getStore } from '../../Store'
const store = getStore();


const CreateDensityNetworkConfigFromParent = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const parent_id = queryParameters.get("id")
    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true);
    const [availableHyperparameters, setAvailableHyperparameters] = useState([]);
    const [id, setID] = useState("");
    const [paramValueList, setParamValueList] = useState([]);
    const [errorMessages, setErrorMessages] = useState({});

    useEffect(() => {
        SelectGenericFromTable("select * from dnc_param where id not in (select parent_id from dnc_param where parent_id is not null) and id not in (select object_id from dnc_param where object_id is not null);", setAvailableHyperparameters)
    }, []);

    useEffect(() => {
        validateForm()
    }, [errorMessages])

    const validateForm = () => {
        const has_errors = Object.keys(errorMessages).map(x => errorMessages[x]).some(x => x !== "")
        const has_values = Object.keys(paramValueList).map(x => paramValueList[x]).some(x => x !== "")
        setSubmitButtonDisabled(has_errors || !has_values)
    }

    const setAndCheckValue = (id, newValue, type, minValue, maxValue) => {
        if (type === "int" || type === "float") {
            if (minValue !== null && parseFloat(newValue) < minValue) {
                setErrorMessages(errorMessages => ({ ...errorMessages, [id]: "Value must be greater than " + minValue }))
            }
            else if (maxValue !== null && parseFloat(newValue) > maxValue) {
                setErrorMessages(errorMessages => ({ ...errorMessages, [id]: "Value must be less than " + maxValue }))
            }
            else {
                setErrorMessages(errorMessages => ({ ...errorMessages, [id]: "" }))

                let index = paramValueList.findIndex(x => x.dnc_param_id === id)
                if (index === -1) {
                    setParamValueList(paramValueList => [...paramValueList, { "dnc_param_id": id, "value": newValue }])
                } else {
                    setParamValueList(paramValueList => paramValueList.map(x => x.dnc_param_id === id ? { "dnc_param_id": id, "value": newValue } : x))
                }
            }
        }
        validateForm()
    }

    const createDensityNetworkConfig = () => {
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Create_Density_Network_Config_From_Param_Value_List",
                "parent_id": parent_id,
                "title": id,
                "param_value_list": paramValueList,
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully created Density Network Config!")
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                HandleAuthError()
            } else {
                console.log(error?.response?.data)
                const stackTraceMessage = GenericStackTraceValidator(error?.response?.data, "Density Network Config")
                if (stackTraceMessage != null) {
                    store.updateErrorMessage(stackTraceMessage)
                } else {
                    store.updateErrorMessage("Error while creating heat map")
                }
            }
        })
    }

    return (
        <Box>
            <Typography sx={{ marginBottom: '20px' }} variant="h6">Generate Adjustment Density Network Config </Typography>
            Parent ID: <b>{parent_id}</b>
            <Box sx={{ m: 2 }}>
                <Stack>
                    <b>ID:</b> {id}
                    <FormControl style={{ width: '216px' }}>
                        <TextField
                            onChange={(event) => setID(event.target.value)} />
                    </FormControl>
                </Stack>
            </Box>
            {availableHyperparameters.map(x =>  
                <Box sx={{ m: 2 }}>
                    <Stack>
                        <b>{x.name} ({x.type}):</b> {x.description}
                        {errorMessages[x.id] !== undefined && <Typography color="red">{errorMessages[x.id]}</Typography> }
                        <FormControl style={{ width: '216px' }}>
                            <TextField
                                onChange={(event) => setAndCheckValue(x.id, event.target.value, x.type, x.min_value, x.max_value)} />
                        </FormControl>
                    </Stack>
                </Box>
            )}
            <Divider />
            <Box sx={{ m: 2 }}>
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button href={"edit-density-network-config?id=" + parent_id}>Cancel</Button>
                    <Button
                        variant="contained"
                        onClick={() => createDensityNetworkConfig()}
                        disabled={isSubmitButtonDisabled}
                    >
                        Submit
                    </Button>
                </Stack>
            </Box>
        </Box>
    )
}

export default CreateDensityNetworkConfigFromParent;